import { cubicEaseOut } from '@helpers/animate';
import { imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid, siteWide } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { ComponentTheme } from '@helpers/themeEnum';
import { caption, h3, paragraph, paragraphSmall } from '@helpers/typography';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import styled from 'styled-components';
const Container = styled.div `
  --bgColour: ${brand.orange.light};
  background-color: var(--bgColour);
  padding-top: ${fluid(40, 120)};
  padding-bottom: ${fluid(40, 60)};

  &[data-theme=${ComponentTheme.Green}] {
    --bgColour: ${brand.green.light};
  }

  &[data-theme=${ComponentTheme.Blue}] {
    --bgColour: ${brand.blue.light};
  }

  &[data-theme=${ComponentTheme.Yellow}] {
    --bgColour: ${brand.yellow.light};
  }
`;
const InnerGrid = styled.div `
  ${siteWide};
  padding-bottom: ${fluid(40, 80)};

  @media ${from(Device.Tablet)} {
    ${baseGrid};
  }
`;
const SectionTitleArea = styled.div `
  grid-column: span 5;

  @media ${from(Device.DesktopLarge)} {
    grid-column: 2 / span 4;
  }
`;
const SectionContent = styled.p `
  grid-column: 7 / span 6;
  ${paragraph};
  margin-bottom: 0;

  @media ${from(Device.DesktopLarge)} {
    grid-column: 7 / span 5;
  }
`;
const SectionCaption = styled.span `
  ${caption};
`;
const SectionTitle = styled.h2 `
  ${h3};
  margin-bottom: 0;
`;
const MediaHolder = styled.div `
  grid-column: span 4;

  @media ${from(Device.Tablet)} {
    ${imageWrapperPreserveRatio(450, 292, 450, 292)}
    margin-top: 40px;
    height: auto;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-column: 2 / span 4;
  }

  @media ${until(Device.Tablet)} {
    margin: 0 auto;
  }
`;
const SectionImageDesktop = styled.img ``;
const SectionImageMobile = styled(SectionImageDesktop) `
  display: none;

  @media ${until(Device.Tablet)} {
    height: 215px;
    object-fit: contain;
    object-position: center;
    display: block;
    margin: 0 auto;

    + ${SectionImageDesktop} {
      display: none;
    }
  }
`;
const Downloads = styled.div `
  grid-column: 6 / span 7;

  @media ${from(Device.DesktopLarge)} {
    grid-column: 6 / span 6;
  }

  @media ${until(Device.Tablet)} {
    margin-top: 40px;
  }
`;
const DownloadItem = styled.div `
  --borderColour: ${brand.orange.base};
  border-bottom: 1px solid var(--borderColour);
  padding: 32px 0;

  &:first-child {
    padding-top: 0;
  }

  ${Container}[data-theme=${ComponentTheme.Green}] & {
    --borderColour: ${brand.green.base};
  }

  ${Container}[data-theme=${ComponentTheme.Blue}] & {
    --borderColour: ${brand.blue.base};
  }

  ${Container}[data-theme=${ComponentTheme.Yellow}] & {
    --borderColour: ${brand.yellow.base};
  }

  @media ${from(Device.TabletSmall)} {
    display: flex;
  }
`;
const DownloadItemContent = styled.div `
  max-width: 556px;
`;
const DownloadItemTitle = styled.h3 `
  ${fonts.montserrat.medium};
  font-size: ${fluid(22, 22)};
  line-height: ${fluid(34, 34)};
  margin-bottom: 0.8rem;
`;
const DownloadItemText = styled.p `
  ${paragraphSmall};
  margin-bottom: 0;
`;
const DownloadItemLinks = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-grow: 1;
  flex-shrink: 0;
  padding-left: ${fluid(30, 40)};

  @media ${until(Device.TabletSmall)} {
    flex-direction: row;
    align-items: center;
    margin-top: 22px;
    padding-left: 0;
  }
`;
const DownloadItemIcon = styled.a `
  margin-right: 18px;
  transition: transform 0.25s ${cubicEaseOut};

  &:hover {
    transform: translateY(5px);
  }

  @media ${from(Device.TabletSmall)} {
    margin-right: 0;
    margin-bottom: 50px;
  }
`;
const DownloadItemIconDesktop = styled.div `
  @media ${until(Device.TabletSmall)} {
    display: none;
  }
`;
const DownloadItemIconMobile = styled.div `
  display: none;

  @media ${until(Device.TabletSmall)} {
    display: block;
  }
`;
const DownloadItemIconCustom = styled.img `
  max-width: 50px;
  height: auto;
  max-height: 65px;
`;
const DownloadItemCta = styled(LinkButton) `
  --hoverColour: ${brand.orange.base};

  ${Container}[data-theme=${ComponentTheme.Green}] & {
    --hoverColour: ${brand.green.base};
  }

  ${Container}[data-theme=${ComponentTheme.Blue}] & {
    --hoverColour: ${brand.blue.base};
  }

  ${Container}[data-theme=${ComponentTheme.Yellow}] & {
    --hoverColour: ${brand.yellow.base};
  }
`;
export const CourseContentDownloadStyles = {
    Container,
    DownloadItem,
    DownloadItemContent,
    DownloadItemCta,
    DownloadItemIcon,
    DownloadItemIconCustom,
    DownloadItemIconDesktop,
    DownloadItemIconMobile,
    DownloadItemLinks,
    DownloadItemText,
    DownloadItemTitle,
    Downloads,
    InnerGrid,
    MediaHolder,
    SectionCaption,
    SectionContent,
    SectionImageDesktop,
    SectionImageMobile,
    SectionTitle,
    SectionTitleArea,
};
